export const closeAllTooltip = () => {
  const tooltips = document.querySelectorAll(".tooltip.in");
  tooltips.forEach((box) => {
    box.remove();
  });
};
